"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as t } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as h } from "../../theme-variant-context.js";
import { vars as i } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: l, size: e = 24 } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const a = h(), r = l !== null && l !== void 0 ? l : a ? i.colors.inverse : i.colors.neutralHigh, { skinName: c } = n();
    return c.match(/^vivo-new/i) ? /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ t("path", {
            fill: r,
            d: "M10.536 4.14c.646-1.134 2.281-1.134 2.927 0l8.003 14.054a1.684 1.684 0 0 1-1.463 2.517H3.996a1.684 1.684 0 0 1-1.463-2.517zm.814 5.626v4.25a.625.625 0 0 0 1.25 0v-4.25a.625.625 0 1 0-1.25 0m.625 7.365a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25"
        })
    })) : c.match(/^o2-new/i) ? /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ t("path", {
            fill: r,
            d: "M21.892 19.877 12.656 3.375A.8.8 0 0 0 12 3c-.256 0-.545.149-.656.374L2.108 19.877a.7.7 0 0 0 0 .75c.145.225.363.374.62.374h18.545a.7.7 0 0 0 .619-.375c.144-.22.144-.484 0-.748M11.455 9.227c0-.297.256-.561.545-.561s.545.264.545.561v5.776c0 .298-.256.562-.545.562s-.545-.264-.545-.562zm-.363 8.44c0-.522.4-.935.908-.935.507 0 .908.413.908.936s-.4.936-.908.936c-.507 0-.908-.413-.908-.936"
        })
    })) : c.match(/^o2/i) ? /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ t("path", {
            fill: r,
            d: "M21.892 19.877 12.656 3.375A.8.8 0 0 0 12 3c-.256 0-.545.149-.656.374L2.108 19.877a.7.7 0 0 0 0 .75c.145.225.363.374.62.374h18.545a.7.7 0 0 0 .619-.375c.144-.22.144-.484 0-.748M11.455 9.227c0-.297.256-.561.545-.561s.545.264.545.561v5.776c0 .298-.256.562-.545.562s-.545-.264-.545-.562zm-.363 8.44c0-.522.4-.935.908-.935.507 0 .908.413.908.936s-.4.936-.908.936c-.507 0-.908-.413-.908-.936"
        })
    })) : /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ t("path", {
            fill: r,
            d: "M22.886 22.628a.8.8 0 0 0 .019-.79L12.582 1.452C12.438 1.17 12.178 1 11.887 1c-.292 0-.552.172-.693.456L1.091 21.837a.8.8 0 0 0 .025.788c.145.231.41.375.709.375h20.353a.82.82 0 0 0 .708-.372m-11.507-3.317c0-.393.226-.619.62-.619.395 0 .621.226.621.62 0 .393-.229.618-.62.618-.392 0-.62-.225-.62-.619m1.25-2.363c0 .341-.275.616-.617.616a.616.616 0 0 1-.617-.616V8.34c0-.341.276-.616.617-.616.342 0 .617.275.617.616z"
        })
    }));
}, p = s;
export { p as default };
